import {NvdbFeatureType} from '../../../../integration/datacatalog/datacatalog-services';

type GeometryTypes = 'Point' | 'MultiPoint' | 'LineString' | 'MultiLineString' | 'Polygon' | 'MultiPolygon' | 'GeometryCollection';

export const copyGeometryFilter = (selectedGeometryType: GeometryTypes, featureType: NvdbFeatureType) => {
    return ((selectedGeometryType === 'Point' || selectedGeometryType === 'MultiPoint')
        && (featureType.geometryTypes.includes('POINT') || featureType.geometryTypes.includes('MULTIPOINT')))
        || ((selectedGeometryType === 'LineString' || selectedGeometryType === 'MultiLineString')
            && (featureType.geometryTypes.includes('LINE') || featureType.geometryTypes.includes('MULTILINE')))
        || ((selectedGeometryType === 'Polygon' || selectedGeometryType === 'MultiPolygon')
            && (featureType.geometryTypes.includes('POLYGON') || featureType.geometryTypes.includes('MULTIPOLYGON')));
};

export const allGeometriesCompatible = (feature: NvdbFeatureType, selectedGeometryTypes: GeometryTypes[]) => {
    return selectedGeometryTypes.some(type => {
        return copyGeometryFilter(type, feature);
    });
};